import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CustomButton } from '../grid.model';

@Component({
  selector: 'app-grid-row-buttons',
  templateUrl: './grid-row-buttons.component.html',
  styles: []
})
export class GridRowButtonsComponent implements OnInit {
  
    @Input() buttons: CustomButton[];
    @Input() row: any;
    @Output() buttonClicked = new EventEmitter<string>();
    public visibleButtons: CustomButton[];
  
    constructor() { }
  
    ngOnInit() {
      this.visibleButtons = this.buttons.filter(b => this.checkIfCustomButtonVisible(b, this.row));
    }
  
    private checkIfCustomButtonVisible(button, row) {
      if (button.isVisible) {
        return button.isVisible(row);
      } else {
        return true;
      }
    }
  
  }